import { all } from "redux-saga/effects";

import appAndPagePersistence from "../legacy/sagas/AppAndPageSavingSagas";
import applicationSagas from "../legacy/sagas/ApplicationSagas";
import dynamicFormSagas from "../legacy/sagas/DynamicFormSagas";
import embeddingSagas from "../legacy/sagas/EmbeddingSagas";
import errorSagas from "../legacy/sagas/ErrorSagas";
import evaluationsSaga from "../legacy/sagas/EvaluationsSaga";
import localDevServerStatusSaga from "../legacy/sagas/localDevServerStatusSaga";
import userSagas from "../legacy/sagas/UserSagas";
import { createBranchSaga } from "./sagas/createBranch";
import { executeV2ApiWithViewModeSaga } from "./sagas/executeV2ApiWithViewModeSaga";
import initializeUserSaga, { initializeVisitor } from "./sagas/initializeUser";
import initializeWorkflowEditor from "./sagas/initializeWorkflowEditor";
import renameApplicationEntitySaga from "./sagas/renameApplicationEntity";
import agentsSlice from "./slices/agents";
import { aiSaga } from "./slices/ai/sagas";
import formatV2ApiStepsSaga from "./slices/apisV2/formatCodeSaga";
import apiPermissionsSaga from "./slices/apisV2/sagas/getApiPermission";
import { apiUndoRedoListenerSaga } from "./slices/apisV2/sagas/replay";
import apisV2Slice from "./slices/apisV2/slice";
import { getAvailableWidgetsSaga } from "./slices/availableWidgets";
import commitsSlice from "./slices/commits";
import datasourcesSlice from "./slices/datasources";
import deploymentsSlice from "./slices/deployments";
import featureFlags from "./slices/featureFlags";
import organizationsSlice from "./slices/organizations";
import repoConnectionsSlice from "./slices/repositories";
import userSlice from "./slices/user";
import { initializeSaga, spawnSaga } from "./utils/effects";

const ROOT_SAGAS = [
  initializeUserSaga,
  initializeVisitor,
  initializeWorkflowEditor,
  getAvailableWidgetsSaga,
  renameApplicationEntitySaga,
  executeV2ApiWithViewModeSaga,
  createBranchSaga,
  formatV2ApiStepsSaga,
];

const LEGACY_SAGAS = [
  agentsSlice.rootSaga,
  organizationsSlice.rootSaga,
  apisV2Slice.rootSaga,
  datasourcesSlice.rootSaga,
  featureFlags.rootSaga,
  userSlice.rootSaga,
  commitsSlice.rootSaga,
  repoConnectionsSlice.rootSaga,
  deploymentsSlice.rootSaga,
  errorSagas,
  applicationSagas,
  userSagas,
  evaluationsSaga,
  apiUndoRedoListenerSaga,
  localDevServerStatusSaga,
  dynamicFormSagas,
  embeddingSagas,
  apiPermissionsSaga,
  appAndPagePersistence,
  aiSaga,
];

export default function* rootSaga() {
  yield all([
    ...LEGACY_SAGAS.map(spawnSaga),
    ...ROOT_SAGAS.map(initializeSaga),
  ]);
}
